// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SyDN","rootNoMargin":"styles_rootNoMargin__1SRDj"};